import { AxiosResponse } from "axios";

import { IDiagnosis } from "../@types/Diagnosis";
import { api } from "./api";

export const diagnosisService = {
  async searchDiagnoses(
    search: string,
    limit = 50
  ): Promise<AxiosResponse<IDiagnosis[]>> {
    return api.get("/Shared/Diagnoses", { params: { search, limit } });
  },
};
